var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gjw-dialog',{staticClass:"progress-dialog",attrs:{"show-dialog":_vm.dialogVisible,"config":{ showFooter: false, width: '300px' }}},[_c('div',{staticClass:"progress-container"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":10,"show-text":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }